import { useSelector } from 'react-redux'
import {selectCurrContacts, selectIsFetched} from '../../../../../slices/contactAddressSlice'
import NowLoading from '../../../../UtilComponent/level_1/NowLoading'
import ContactAddressCard from './ContactAddressCard/ContactAddressCard'

const ContactAddressCardList = () => {
  const contactAddresses = useSelector(selectCurrContacts)
  const isFetched = useSelector(selectIsFetched)

  return (
    <div className="stack">
      {isFetched ? (
        contactAddresses.length !== 0 ? (
          contactAddresses.map((contactAddress) => (
            <ContactAddressCard
              key={contactAddress.id}
              contactAddress={contactAddress}
            />
          ))
        ) : (
          <span>
            連絡先は見つかりませんでした。新しい連絡先を作成してください。
          </span>
        )
      ) : (
        <span>
          <NowLoading />
          データを取得中です。
        </span>
      )}
    </div>
  )
}

export default ContactAddressCardList
